import React, { useContext } from "react";
import { LanguageContext } from "../../../../../Context";


export default function StoppedReason({history, vn=false}) {
const {language} = useContext(LanguageContext)
if(!history || history.length===0) return <></>
const h = history[history.length-1]
    if (vn) return <>{h.reason}</>
return(<>{h.reason_en && language===0 ? h.reason_en : h.reason}</>)
}